import ClientList from '@/modules/user/client/components/List';
import CuratorList from '@/modules/user/curator/components/List';
import ClientProfile from '@/modules/user/client/components/Profile';
import AppealsLayout from '@/modules/dashboardParent/components/AppealsLayout';
import UndesirableBehaviorLayout
  from '@/modules/dashboardParent/components/UndesirableBehaviorLayout';
import UserDashboardLayout
  from '@/modules/user/client/components/UserDashboardLayout';

import CuratorProfile from '@/modules/user/curator/profile/components/Profile';

import canViewClient from '../../../../router/hooks/canViewCleint';
import canViewClients from '../../../../router/hooks/canViewClients';
import canViewCurators from '../../../../router/hooks/canViewCurators';
import canViewCurator from '../../../../router/hooks/canViewCurator';

import droRoutes from '../../../dro/routes';
import rotationRoutes from '../../../randomRotation/routes';

export default [
  {
    path: '/users',
    component: UserDashboardLayout,
    children: [
      {
        path: 'clients',
        name: 'client',
        component: ClientList,
        beforeEnter: canViewClients,
      },
      {
        path: 'clients/:clientId/edit',
        name: 'client-edit',
        component: ClientProfile,
        props: true,
        beforeEnter: canViewClient,
      },
      {
        path: 'clients/:clientId/appeals',
        name: 'client-appeals',
        component: AppealsLayout,
        props: true,
        beforeEnter: canViewClient,
      },
      {
        path: 'clients/:clientId/undesirable-behavior',
        name: 'client-undesirable-behavior',
        component: UndesirableBehaviorLayout,
        props: true,
        beforeEnter: canViewClient,
      },
      {
        path: 'curators',
        name: 'curator',
        component: CuratorList,
        beforeEnter: canViewCurators,
      },
      {
        path: 'curators/:id/edit',
        name: 'curator-edit',
        component: CuratorProfile,
        beforeEnter: canViewCurator,
        props: true,
      },
    ].concat(droRoutes, rotationRoutes)
  },
];



// WEBPACK FOOTER //
// ./src/modules/user/client/routes/index.js